import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form } from "react-bootstrap";
import BreadcrumbsSection from "../breadcrumbs/BreadcrumbsSection";
import SelectDropDown from '../selectdropdown/SelectDropDown'
import { components } from 'react-select'
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { log } from "logrocket";
import { withApollo } from "react-apollo";
import CardLessDataTable from '../datatables/CardLessDataTableWithSearch';
import moment from "moment";
import CreateExamModal from './createExamModal';
import CreateExamCategory from './examCategoryModal';
import MarksUploadingModal from './marksUploadModal';
import './_studentMarks.scss';
import DateBlock from '../home/DateBlock';



const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

const FETCH_GLOBALS = gql`
  query($institution_id: Int!) {
    globals(institution_id: $institution_id) {
        b_e_c_s_data {
            section_id
            class_id
            branch_id
            exam_id
          }
          educationalClasses {
            id
            class
          }
      globalPackages {
        id
        package_name
        exams_covered
      }
      globalCategories {
        id
        category_name
        package_id
      }
      classes {
        id
        class
      }
      exams {
        id
        exam
        exam_subjects{
            subject_id
        }
      }
      globalBranches {
        id
        branch_name
      }
      globalSections {
        id
        section_name
        branch_id
        category_id
        package_id
      }
      offlineExamSubjects{
        id
        subject
      }
    }
  }
`;

class StudentMarksUploadingSection extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modalShow: false,
            marksUploadModal: false,
            defaultvalue: 0,
            section: "",
            class: "",
            exam: "",
            branch: "",
            branchError: "",
            classError: "",
            examError: "",
            sectionError: "",
            submitError: "",
            examName: "",
            examNameError: "",
            startdate: "",
            dateError: "",
            rows: [],
            cols: [],
            dataClear: 0,
            examType: "",
            examTypeError: "",
            getOfflineExamPapers: [],
            loader: 0,
            startDateCalender: moment(new Date()).subtract(1, "year").unix(),
            endDateCalender: moment(new Date()).unix(),
            modalShow1: false,
            getExams: [],
            getClasses: [],
            submitted:false
        }
    }

    articlecolumns = [
        {
            dataField: "branch_name",
            text: "Branch",
        },

        {
            dataField: "exam_name",
            text: "Exam",
        },

        // {
        //     dataField: "class_name",
        //     text: "Class",
        // },
        {
            dataField: "exam_category_name",
            text: "Pattern Name",
        },
        {
            dataField: "",
            text: "Total Marks",
            formatter: this.marksDetails.bind(this)
        },
    ];

    marksDetails(cell, row, rowIndex, formatExtraData) {
        console.log("row", row);
        let subjectsArray = []
        row.total_marks.map((item) => {
            let filteredSubjects = this.props?.globals.globals?.offlineExamSubjects.filter((item1) => item1.id == item.subject_id);
            const newObj = {
                value: filteredSubjects[0].id,
                label: filteredSubjects[0].subject
            }
            subjectsArray.push(`${filteredSubjects[0].subject}:${item.total_marks}`)
        })
        return (
            <>
                <p>{subjectsArray.toString()}</p>
            </>
        )
    }

    uploadMarks = (e, row) => {
        this.setState({ marksUploadModal: true })
    }

    handleInputChange = e => {
        const name = e.target.name;
        const value = e.target.value;


        let getArray = [];

        if (name == "branch") {

            if (value != "0") {

                let uniqueExams = [...new Set(this.props.globals.globals.b_e_c_s_data.filter((item) => item.branch_id == value).map((item1) => item1.exam_id))].sort();

                console.log("uniqueExams", uniqueExams, this.props.globals.globals);
                uniqueExams.map((val) => {
                    let individualExamData = this.props.globals.globals.exams.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualExamData.id,
                        label: individualExamData.exam
                    }
                    getArray.push(newObj);
                })

                this.setState({
                    getExams: getArray,
                    branchError: "",
                    classError: "",
                    examError: "",
                    branch: value,
                    exam: "",
                    getClasses: [],
                    class: "",
                    getOfflineExamPapers: []
                })
            } else {
                this.setState({
                    getExams: [],
                    branchError: "",
                    classError: "",
                    examError: "",
                    branch: value,
                    exam: "",
                    getClasses: [],
                    class: "",
                    getOfflineExamPapers: [],
                    submitted:false

                })
            }
        } else if (name == "exam") {

            if (value != "0") {

                let uniqueClasses = [...new Set(this.props.globals.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branch && item.exam_id == value).map((item1) => item1.class_id))].sort();

                uniqueClasses.map((val) => {
                    let individualClassData = this.props.globals.globals.educationalClasses.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualClassData.id,
                        label: individualClassData.class
                    }
                    getArray.push(newObj);
                })

                this.setState({
                    getClasses: getArray,
                    branchError: "",
                    classError: "",
                    examError: "",
                    exam: value,
                    class: "",
                    getOfflineExamPapers: [],
                    submitted:false
                })
            } else {
                this.setState({
                    getClasses: [],
                    branchError: "",
                    classError: "",
                    examError: "",
                    exam: "",
                    class: "",
                    getOfflineExamPapers: [],
                    submitted:false

                })
            }
        } else if (name == "class") {

            if (value != "0") {
                this.setState({
                    classError: "",
                    class: value,
                    getOfflineExamPapers: [],
                    submitted:false
                })
            } else {
                this.setState({
                    classError: "",
                    class: "",
                    getOfflineExamPapers: [],
                    submitted:false

                })
            }
        }

    };


    getExamPapers = async (e) => {

        if (this.state.branch == "") {
            this.setState({ branchError: "Please select branch" });
            return ""
        }
        if (this.state.exam == "") {
            this.setState({ examError: "Please select exam" });
            return ""
        }

        // if (this.state.class == "") {
        //     this.setState({ classError: "Please select class" });
        //     return ""
        // }



        this.setState({ loader: 1 })

        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,$exam_id:Int,$class_id:Int){
                getInstituteExamCategories(institute_id:$institute_id,branch_id:$branch_id,exam_id:$exam_id,class_id:$class_id){
                    id
                    total_marks
                    exam_category_name
                    branch_id
                    exam_id
                    class_id
                    branch_name
                    class_name
                    exam_name
                  }
               }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branch),
                exam_id: parseInt(this.state.exam),
                class_id: parseInt(this.state.class)
            },
            fetchPolicy: 'network-only'
        })

        console.log("")


        if (result.data.getInstituteExamCategories.length > 0) {
            this.setState({
                loader: 0,
                getOfflineExamPapers:result.data.getInstituteExamCategories,
                submitted:false
            })
        } else {
            this.setState({ getOfflineExamPapers: [],submitted:true,loader:0 })
        }
    }

    applyCallback = (startDate, endDate) => {


        this.setState({
            startDateCalender: startDate.unix(),
            endDateCalender: endDate.unix(),
            getExams: [],
            branchError: "",
            classError: "",
            examError: "",
            branch: "",
            exam: "",
            getClasses: [],
            class: "",
            getOfflineExamPapers: [],
            getClasses: [],
            submitted:false
        })
    }


    render() {
        console.log("chaitu", this.state)

        const globals = this.props.globals;
        const loading1 = globals.loading;
        const error1 = globals.error;

        if (loading1) return null;

        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        let globalsData = [];

        if (!loading1) {
            globalsData = this.props.globals.globals
        }

        let sections = [];
        if (this.state.exam != "") {
            globalsData.globalPackages.map((item) => {
                if (item.exams_covered == this.state.exam) {
                    globalsData.globalCategories.map((stumap) => {
                        if (stumap.package_id == item.id) {
                            globalsData.globalSections.map((stumap1) => {
                                if (stumap1.category_id == stumap.id) {
                                    const newObj = {
                                        id: stumap1.id,
                                        section_name: stumap1.section_name
                                    }
                                    sections.push(newObj);
                                }
                            })

                        }

                    });
                }
            });
        }

        return (
            <Container className="student_marks">
                <Row className="breadcrumb_section border-bottom border-theme pb-1 my-4">
                    <Col lg={6} sm={12}>
                        <h2 className="title h5 mb-0">Offline Exams Marks Upload</h2>
                    </Col>
                    <Col lg={3} sm={12}>
                        <Button  className="text-uppercase px-4 Create_Exam_btn" onClick={() => this.setState({ modalShow1: true })}>Create Exam pattern</Button>
                    </Col>
                    <Col lg={3} sm={12}>
                        <Button className="text-uppercase px-4 Create_Exam_btn" onClick={() => this.setState({ modalShow: true })}>Create & Upload Marks</Button>
                    </Col>
                </Row>

                <Row>
                    <Col sm={12}>
                        <h5 className="title h5 mb-0 text-center">Offline Exams Pattern Details</h5>
                    </Col>
                </Row>

                <Row className="mt-1">
                    <Col sm={12}>
                        <Form>
                            <Form.Row>
                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectClass">
                                    <Form.Label className="text-uppercase">Branch</Form.Label>
                                    <Form.Control as="select" name="branch" onChange={this.handleInputChange} value={this.state.branch}>
                                        <option value={this.state.defaultvalue}>--Select Branch--</option>
                                        {globalsData.globalBranches.map(branchData => (
                                            <option value={branchData.id}>{branchData.branch_name}</option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger">
                                        {this.state.branchError}
                                    </Form.Text>
                                </Form.Group>
                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="Selectexam">
                                    <Form.Label className="text-uppercase">Exam</Form.Label>
                                    <Form.Control as="select" name="exam" onChange={this.handleInputChange} value={this.state.exam}>
                                        <option value={this.state.defaultvalue}>--Select Exam--</option>
                                        {this.state.getExams.map(item => (
                                            <option value={item.value}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger">
                                        {this.state.examError}
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="Selectexam">
                                    <Button className="btn btn-success text-uppercase submit_btn" onClick={(e) => this.getExamPapers()}>Submit</Button>
                                </Form.Group>

                            </Form.Row>
                        </Form>
                    </Col>
                </Row>

                {
                    this.state.getOfflineExamPapers.length > 0 ?
                        (
                            <Row>
                                <Col sm={12}>
                                    <CardLessDataTable
                                        parentData={this.state.getOfflineExamPapers}
                                        particlecolumns={this.articlecolumns}
                                        searchBar={false}
                                    />
                                </Col>
                            </Row>
                        )
                        :
                        (
                            <Row>
                                <Col sm={12}>
                                    <div className={this.state.loader == 1 ? "d-flex align-items-center spinner-border text-primary text-center loading-img-center" : ""} >
                                    </div>
                                </Col>
                                <Col sm={12}>
                                    {
                                        this.state.submitted  ?
                                            (<h6 className="text-center mt-5">No Data Available</h6>)
                                            :
                                            ("")
                                    }
                                </Col>
                            </Row>
                        )
                }

                <CreateExamModal
                    stateData={this.state}
                    show={this.state.modalShow}
                    onHide={() => this.setState({ modalShow: false })}
                    globals={globals.globals}
                />
                <CreateExamCategory
                    stateData={this.state}
                    show={this.state.modalShow1}
                    onHide={() => this.setState({ modalShow1: false })}
                    globals={globals.globals}
                />
                <MarksUploadingModal
                    show={this.state.marksUploadModal}
                    onHide={() => this.setState({ marksUploadModal: false })}
                />
            </Container>
        )
    }
}

export default withRouter(withApollo(compose(
    graphql(FETCH_GLOBALS, {
        options: (props) => ({
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
            },
        }),
        name: "globals",
    }),
)(StudentMarksUploadingSection))
);